import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const fetchOrg = createAsyncThunk(
  "Setup/fetchOrg",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.GET_ORG);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const createOrg = createAsyncThunk(
  "Setup/createOrg",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_ORG,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const updateOrg = createAsyncThunk(
  "Setup/updateOrg",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.UPDATE_ORG,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const fetchDashboard = createAsyncThunk(
  "Setup/fetchDashboard",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.ADMIN_DASHBOARD}?userId=${userId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  loading: false,
  error: null,
  data: null,

  createLoading: false,
  createError: null,
  createData: null,

  updateLoading: false,
  updateError: null,
  updateData: null,

  dashboardLoading: false,
  dashboardError: null,
  dashboardData: null,
};

// ------------------ SLICE ------------------
const OrgSlice = createSlice({
  name: "Setup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // LOGIN USER
    builder
      .addCase(fetchOrg.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrg.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchOrg.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createOrg.pending, (state) => {
        state.createLoading = true;
        state.createError = null;
      })
      .addCase(createOrg.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createData = action.payload;
      })
      .addCase(createOrg.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload;
      })

      .addCase(updateOrg.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
      })
      .addCase(updateOrg.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateData = action.payload;
      })
      .addCase(updateOrg.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
      })

      .addCase(fetchDashboard.pending, (state) => {
        state.dashboardLoading = true;
        state.dashboardError = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.dashboardLoading = false;
        state.dashboardData = action.payload;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.dashboardLoading = false;
        state.dashboardError = action.payload;
      });
  },
});

export default OrgSlice.reducer;
